import React from 'react';
import TabMenuItem, { TabMenuItemGeneral, TabMenuItemResult, TabText } from '../TabMenuItem/TabMenuItem';
import './TabMenu.scss';

interface TabMenuProps {
  items: TabMenuItemGeneral[] | TabMenuItemResult[];
  onClick?: (tab: TabText) => void;
}

const TabMenu = ({ items, onClick }: TabMenuProps) => {
  const isSelected = items.some((item) => item.type === 'general' && item.selectionMade);
  const isResult = items.some((item) => item.type === 'result');
  const tabs = items.map((item, i) => {
    if (item.type === 'general') item.onClick = onClick;
    return <TabMenuItem key={i} {...item} />;
  });

  const tabMenu = <div className={`tab-menu${isResult ? '__result' : ''}`}>{tabs}</div>;
  if (isResult) return tabMenu;
  return (
    <div className={`${isSelected ? 'tab-menu-container--selected-margin' : 'tab-menu-container'}`}>{tabMenu}</div>
  );
};
export default TabMenu;
